import React from "react";
import { Redirect, Link } from "react-router-dom";
import { logoImage } from "../../../../assets";

export default function Headers() {
  return (
    <div className="main-bg">
      <header>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center text-lg-left">
              <div className="log pt-2 ">
                <Link to="/dashboard">
                  <img src={logoImage} height="48px" alt="LA Moving Start" title="LA Moving Star" />
                </Link>
              </div>
            </div>

            {/* <div className="col-6 text-right">
              <div className="header-icons-wrapper">
                {localStorage.getItem("token") && (
                  <div className="help pointer-point">Help</div>
                )}
              </div>
            </div> */}
          </div>
        </div>
      </header>
    </div>
  );
}
